module.exports = __webpack_public_path__ + "static/media/blom-pysanky-111.d450264b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-111.jpg
// module id = 3674
// module chunks = 15